import React from "react";
import ReuseableButton from "../../components/Buttons/button";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import useIPDHook from "./ipdHooks";
import { DataGrid } from '@mui/x-data-grid';
import { userColumns } from "./ipdColum";
import "./ipdList.scss";

const IPDList = () => {
    const { handleAddIPDRoute, ipdList, handleGetRowId, handleAddVoucher } = useIPDHook()
    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <div className="viewButton" 
                        onClick={() => handleAddVoucher(params.row)}
                        >Add Vocuher</div>
                        <div
                            className="deleteButton"
                            // onClick={(e) => handleDelete(e, params.row)}
                        >
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className='d-flex justify-content-end'>
                <div className="mr-5">
                    <ReuseableButton
                        text={"Add IPD"}
                        height={45}
                        colorVarient="success"
                        fullWidthFlag={true}
                        endIcon={<PersonAddAltIcon />}
                        handleChange={handleAddIPDRoute}
                    />
                </div>
            </div>
                <div className="ipd-table p-2">
                <DataGrid
                    autoHeight
                    rows={ipdList && ipdList?.length > 0 ? ipdList : []}
                    loading={ipdList?.length > 0 || ipdList === null ? false : true}
                    columns={userColumns.concat(actionColumn)}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                />
            </div>
        </>
    )
}

export default IPDList